import { render } from "./ChoiceProduct.vue?vue&type=template&id=a6065fa2&scoped=true"
import script from "./ChoiceProduct.vue?vue&type=script&lang=js"
export * from "./ChoiceProduct.vue?vue&type=script&lang=js"

import "./ChoiceProduct.vue?vue&type=style&index=0&id=a6065fa2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6065fa2"]])

export default __exports__